<template>
  <v-select
    v-if="show"
    v-model="mainFilters.project"
    :items="projects"
    item-text="name"
    :label="$t('views.statistics.filter')"
    multiple
    no-data-text="No project found"
    outlined
    return-object
  >
    <template #selection="{ item, index }">
      <span v-if="index == 0">
        {{ selectedItemText }}
      </span>
    </template>

    <template #prepend-item>
      <v-list-item
        ripple
        @mousedown.prevent
        @click="toggle"
      >
        <v-list-item-action>
          <v-icon :color="mainFilters.project.length > 0 ? 'error' : 'primary'">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> Select All </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "MenuFilters",
  props: {
    projects: {
      type: Array
    },
    mainFilters: {
      project: {
        type: Object
      }
    },
    show: {
      type: Boolean
    }
  },
  data() {
    return {}
  },
  computed: {
    selectedItemText() {
      return this.mainFilters.project.length > 1
        ? this.mainFilters.project[0].name + " ..."
        : this.mainFilters.project[0].name
    },
    allProjects() {
      return this.mainFilters.project.length === this.projects.length
    },
    someProjects() {
      return this.mainFilters.project.length > 0 && !this.allProjects
    },
    icon() {
      if (this.allProjects) return "mdi-close-box"
      if (this.someProjects) return "mdi-minus-box"
      return "mdi-checkbox-blank-outline"
    }
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.allProjects) {
          this.mainFilters.project = []
        } else {
          this.mainFilters.project = this.projects.slice()
        }
      })
    }
  }
}
</script>

<style scoped lang="css">
.disabled {
  color: red;
}
</style>
